import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';
import axios from 'axios';
import { isMobile } from '../../../actions/utils';

const axiosInstance = axios.create({
  baseURL: '/api',
});

const middleware = [thunk.withExtraArgument(axiosInstance)];

const setStore = (initialState) => {
  const settings = initialState.settings
    ? { ...initialState.settings }
    : {
        ...initialState.defaultSettings,
      };
  const design = initialState.design;
  const constants = initialState.constants;
  const store = createStore(
    reducers,
    {
      settings,
      design,
      constants,
      isMobile,
      styleParams: {},
    },
    applyMiddleware(...middleware),
  );
  return store;
};

export default (initialState) => {
  initialState = initialState || {};
  return setStore(initialState);
};
